import { toHtml } from "../components/MathText"

// Tipografa LaTeX ($...$/$$...$$) em conteúdo server-rendered (páginas públicas
// de provas anteriores): o servidor entrega o texto bruto — que é o que o
// Google indexa — e aqui cada nó de texto dentro de `.js-math` vira KaTeX.
// Mesmo pipeline do RichContent (toHtml escapa o resto e protege "R$").
export function enhanceMath() {
  document.querySelectorAll<HTMLElement>(".js-math").forEach((el) => {
    if (!el.textContent?.includes("$")) return

    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT)
    const nodes: Text[] = []
    while (walker.nextNode()) nodes.push(walker.currentNode as Text)

    for (const node of nodes) {
      const text = node.textContent || ""
      if (!text.includes("$")) continue
      const span = document.createElement("span")
      span.innerHTML = toHtml(text)
      node.replaceWith(span)
    }
  })
}
